import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { AppContext } from "../App";

export default function DropLi() {
  const { t } = useTranslation();
  const { settings } = useContext(AppContext);

  const AccBalTypes = [
    { id: 1, label: t("no") },
    { id: 2, label: t("yesWithNoBalanceLimit") },
    { id: 3, label: t("yesButWithABalanceLimit") },
  ];

  const CloseRegTypes = [
    { id: 1, label: t("minimalSimpleAccounts") },
    { id: 2, label: t("detailsWithProductsEtc") },
  ];

  const ReceiptType = [
    { id: 1, label: "Thermal Printer" },
    { id: 2, label: "Normal Printer (A4)" },
  ];

  const PriceLabels = [
    { id: "Regular Price", label: "Regular Price" },
    { id: "Special Price", label: "Special Price" },
    { id: "Wholesale Price", label: "Wholesale Price" },
  ];

  const StoreNameForReceipit = [
    { id: 1, label: t("showLocalNameIfExist") },
    { id: 2, label: t("showBothName") },
    { id: 3, label: t("showNameOnly") },
  ];

  const ProductLabel = [
    { id: 1, label: t("showLocalNameIfExist") },
    { id: 2, label: t("showBothLabel") },
    { id: 3, label: t("showNameOnly") },
  ];

  const Decimals = [
    { id: 1, label: t("allow1Decimal") },
    { id: 2, label: t("allow2Decimal") },
    { id: 3, label: t("allow3Decimal") },
  ];

  const EmailInvoice = [
    { id: 1, label: t("ask") },
    { id: 2, label: t("alwaysSend") },
    { id: 3, label: t("disableThisFeature") },
  ];

  const DiscountTypes = [
    { id: 1, label: "%" },
    { id: 2, label: `${settings ? settings.curSymbol : ""}` },
  ];

  const Gender = [
    { id: 1, label: t("male") },
    { id: 2, label: t("female") },
    { id: 3, label: t("other") },
  ];

  const SalesBy = [
    { id: 1, label: t("today") },
    { id: 2, label: t("thisWeek") },
    { id: 3, label: t("thisMonth") },
    { id: 4, label: t("thisYear") },
  ];

  const Languages = [
    { id: "en", label: "English" },
    { id: "ar", label: "العربية (Arabic)" },
    { id: "bn", label: "বাংলা (Bangla)" },
    { id: "hi", label: "हिन्दी (Hindi)" },
    { id: "zh", label: "中文 (Chinese)" },
    { id: "fr", label: "Français (French)" },
    { id: "es", label: "Español (Spanish)" },
  ];

  const UnitType = [
    { id: 1, label: "Box" },
    { id: 2, label: "PCS" },
    { id: 3, label: "Weighable" },
    { id: 4, label: "Liter" },
    { id: 5, label: "Etc" },
  ];

  const PaymentType = [
    { id: 1, label: t("fullPaid") },
    { id: 2, label: t("due") },
  ];

  const SellType = [
    { id: 1, label: t("paid") },
    { id: 2, label: t("due") },
  ];

  const PayType = [
    { id: 1, label: t("cash") },
    { id: 2, label: t("cardPayment") },
    { id: 3, label: t("credit") },
    { id: 4, label: t("others") },
  ];

  const BoolType = [
    { id: 1, label: t("yes") },
    { id: 2, label: t("no") },
  ];

  const ReturnReason = [
    { id: 1, label: t("mindChange") },
    { id: 2, label: t("dateExpire") },
    { id: 3, label: t("badItem") },
    { id: 4, label: t("damage") },
    { id: 5, label: t("extra") },
    { id: 6, label: t("noSale") },
    { id: 7, label: t("others") },
  ];

  const Prefix = [
    { id: 1, label: t("mr") },
    { id: 2, label: t("mrs") },
    { id: 3, label: t("miss") },
  ];

  const Periodic = [
    { id: 1, label: t("daily") },
    { id: 2, label: t("monthly") },
    { id: 3, label: t("yearly") },
  ];

  const Role = [
    { id: 1, label: t("admin") },
    { id: 2, label: t("manager") },
    { id: 3, label: t("cashier") },
    { id: 4, label: t("employee") },
    { id: 5, label: t("subscriber") },
  ];

  const PordType = [
    { id: 1, label: t("products") },
    { id: 2, label: t("category") },
    { id: 3, label: t("brands") },
  ];

  return {
    PriceLabels,
    SalesBy,
    UnitType,
    BoolType,
    PaymentType,
    PayType,
    ReturnReason,
    Gender,
    Prefix,
    Periodic,
    Role,
    PordType,
    Languages,
    AccBalTypes,
    SellType,
    DiscountTypes,
    Decimals,
    EmailInvoice,
    ReceiptType,
    ProductLabel,
    StoreNameForReceipit,
    CloseRegTypes,
  };
}
